{
    "alts": {
        "closeModal": "Cerrar modal"
    },
    "buttons": {
        "next": "Continuar",
        "tryAgain": "Intentar de nuevo",
        "finish": "Terminar",
        "submit": "Enviar",
        "confirm": "Confirmar",
        "agree": "Estoy de acuerdo",
        "downloadPDF": "Descargar PDF",
        "yes": "Sí",
        "no": "No",
        "verify": "Verificar",
        "skip": "Omitir",
        "close": "Cerrar",
        "consent": {
            "confirmQuietPlace": "Estoy en un lugar tranquilo",
            "confirmYourBest": "Haré lo mejor que pueda",
            "confirmAid": "Confirmo",
            "confirmOnYourOwn": "Lo haré yo mismo",
            "confirmLater": "Volveré más tarde"
        },
        "exit": "Salir",
        "exit2": "No, salir",
        "exit3": "Salir y perder progreso",
        "invite": "Enviar invitación",
        "sendAnotherInvite": "¿Enviar otra invitación?",
        "start": "Iniciar prueba",
        "cantVerifyNow": "No se puede verificar ahora"
    },
    "placeholders": {
        "month": "Mes",
        "year": "Año",
        "day": "Día",
        "location": "Por ejemplo, NW3 6PX"
    },
    "months": [
        "Vacío",
        "Enero",
        "Febrero",
        "Marzo",
        "Abril",
        "Mayo",
        "Junio",
        "Julio",
        "Agosto",
        "Septiembre",
        "Octubre",
        "Noviembre",
        "Diciembre"
    ],
    "errors": {
        "wer": [
            {
                "title": "Uy. No hemos entendido lo que dijo.",
                "instructions": "- Recuerde que la grabación comienza automáticamente.\n- Solamente repita la oración.\n- Cuando termine, pulse el botón parar.",
                "button": "Intentar de nuevo"
            },
            {
                "title": "Mmm. Todavía no entendemos lo que dijo.",
                "instructions": "- Recuerde que la grabación comienza automáticamente.\n- Solamente repita la oración.\n- Cuando termine, pulse el botón parar.",
                "button": "Intentar por última vez"
            }
        ],
        "noise": [
            {
                "title": "Parece que hay ruido de fondo.",
                "instructions": "Primero, encuentre un lugar más tranquilo o apague los dispositivos que estén haciendo ruido (la televisión, música, etc.); asegúrese de que nadie esté hablando en el fondo.",
                "button": "Intentar de nuevo"
            },
            {
                "title": "Parece que todavía hay ruido de fondo.",
                "instructions": "Primero, encuentre un lugar más tranquilo o apague los dispositivos que estén haciendo ruido (la televisión, música, etc.); asegúrese de que nadie esté hablando en el fondo.",
                "button": "Intentar por última vez"
            }
        ],
        "clipping": [
            {
                "title": "La grabación se escucha muy alta.",
                "instructions": "- Considere alejar un poco su micrófono.\n- Intente hablar un poco más bajo.\n- Asegúrese de estar en un lugar silencioso.",
                "button": "Intentar de nuevo"
            },
            {
                "title": "La grabación todavía se escucha muy alta.",
                "instructions": "- Considere alejar un poco su micrófono.\n- Intente hablar un poco más bajo.\n- Asegúrese de estar en un lugar silencioso.",
                "button": "Intentar por última vez"
            }
        ],
        "sex": {
            "error": {
                "required": "Por favor, seleccione cuál fue su sexo al nacer, antes de continuar."
            }
        },
        "email": {
            "error": {
                "duplicate": "Parece que este correo electrónico ya está en uso. Pruebe con otro o contacte al soporte.",
                "required": "Ingrese su dirección de correo electrónico antes de continuar.",
                "pattern": "Esto no parece ser un correo electrónico válido. Intenta con otro o contacta al soporte."
            }
        },
        "consent": {
            "error": {
                "required": "Por favor confirme que está de acuerdo antes de proceder."
            }
        },
        "proficiency": {
            "error": {
                "required": "Seleccione el dominio que tiene del idioma antes de continuar."
            }
        },
        "education": {
            "error": {
                "required": "Por favor, seleccione la opción que refleje mejor su nivel de educación antes de continuar."
            }
        },
        "study_consent": {
            "error": {
                "required": "Confirme su acuerdo para proceder."
            }
        },
        "dob": {
            "error": {
                "required": "Por favor, proporcione su fecha de nacimiento antes de continuar.",
                "composite": "Por favor, proporcione su fecha de nacimiento antes de continuar."
            }
        },
        "location": {
            "error": {
                "required": "Proporcione su código postal antes de continuar.",
                "composite": "Proporcione su código postal antes de continuar."
            }
        },
        "code": {
            "error": {
                "required": "Código incorrecto. Verifique su número de teléfono y solicite otro código.",
                "bad request": "Código incorrecto. Verifique su número de teléfono y solicite otro código."
            }
        },
        "had-impairment-issues": {
            "error": {
                "required": "Por favor, responda si tiene algún problema de visión o audición."
            }
        },
        "got-distracted": {
            "error": {
                "required": "Por favor, responda si logró completar las tareas sin distracciones."
            }
        },
        "someone-else-speaking": {
            "error": {
                "required": "Por favor, responda si hemos grabado a alguien, excepto a usted, durante las tareas."
            }
        },
        "phone": {
            "error": {
                "duplicate": "Parece que este número de teléfono ya está en uso. Pruebe con otro o contacte al soporte técnico.",
                "required": "Ingrese su número de teléfono antes de continuar."
            }
        },
        "isCaregiver": {
            "error": {
                "required": "Elija si la prueba es para usted o para otra persona antes de continuar."
            }
        },
        "isPersonNearby": {
            "error": {
                "required": "Por favor, responda la pregunta antes de continuar."
            }
        },
        "caregiverShare": {
            "error": {
                "required": "Decida cómo prefiere enviar la invitación para la prueba antes de continuar."
            }
        },
        "inviteeEmail": {
            "error": {
                "duplicate": "Parece que este correo electrónico ya está en uso. Intenta con otro o contacta al soporte.",
                "required": "Ingrese la dirección de correo electrónico del destinatario para enviar la invitación de prueba.",
                "minLength": "Ingrese la dirección de correo electrónico del destinatario para enviar la invitación de prueba."
            }
        },
        "inviteePhone": {
            "error": {
                "duplicate": "Parece que este número de teléfono ya está en uso. Intenta con otro o contacta al soporte.",
                "required": "Ingrese el número de teléfono móvil del destinatario para enviar la invitación de prueba.",
                "minLength": "Ingrese el número de teléfono móvil del destinatario para enviar la invitación de prueba."
            }
        }
    },
    "modals": {
        "exit": {
            "caption": "¿Salir de Storyteller?",
            "text": "Podrá volver cuando esté listo.",
            "buttons": {
                "confirm": "Salir",
                "cancel": "No"
            }
        },
        "expired": {
            "caption": "La sesión ha expirado",
            "text": "Su sesión ha terminado por inactividad. Pulse **\"Reiniciar\"** para volver al comienzo de Storyteller.",
            "buttons": {
                "confirm": "Reiniciar",
                "cancel": "Salir"
            }
        },
        "genericError": {
            "caption": "Algo salió mal.",
            "text": "Disculpe las molestias. Parece que algo no funciona correctamente en nuestro sistema. Haga clic en **Intentar de nuevo** para continuar. Si el problema continúa, contáctese con el soporte técnico.",
            "buttons": {
                "confirm": "Intentar de nuevo",
                "cancel": "Salir"
            }
        },
        "soundCheck": {
            "caption": "¿Escuchó el sonido?"
        },
        "completeStreaming": {
            "caption": "¿Ha terminado?"
        }
    },
    "phone": {
        "resend": "Solicitar otro código",
        "change": "Cambiar número de teléfono",
        "timeout": "Solicite otro código en {{counter}}s",
        "prefix": "¡Nuevo código enviado!"
    },
    "consent": {
        "title": "Consentimiento",
        "description": "Lea cuidadosamente el formulario de consentimiento e indique su acuerdo."
    },
    "recording": "Grabación en proceso",
    "streaming": {
        "play": "Pulse para comenzar",
        "playing": "Escuche",
        "record": "Pulse para comenzar",
        "recordingAutomatic": "Hable",
        "recordingManual": "Pulse para parar"
    },
    "soundCheck": {
        "audioStart": "Chequear el sonido",
        "audioStop": "Escuche"
    },
    "options": {
        "proficiency": {
            "native": "Nativo",
            "fluent": "Fluido",
            "not-native-or-fluent": "No nativo o fluido"
        },
        "language": {
            "en-US": "Inglés (USA)",
            "en-GB": "Inglés (Reino Unido)",
            "es-US": "Español (USA)"
        },
        "novoicConsent": [
            "He leído y aceptado los Términos de Uso y la Política de Privacidad. Entiendo que Storyteller no proporciona asesoramiento médico ni recomendaciones de salud. Entiendo que puedo ser contactado para discutir mis resultados."
        ],
        "yes": "Sí",
        "no": "No",
        "csat": {
            "low": "Para nada",
            "high": "Mucho"
        },
        "csatADNI": {
            "low": "Para nada",
            "high": "Mucho"
        },
        "studyMotivation": {
            "improve_others_life": "Quiero ayudar a mejorar la vida de otros",
            "memory_concerns": "Estoy preocupado por mi memoria",
            "noticed_memory_decline": "He notado un deterioro en mi memoria",
            "relative_with_ad": "Tengo un familiar con la enfermedad de Alzheimer",
            "been_diagnosed_with_ad": "He sido diagnosticado con la enfermedad de Alzheimer o Deterioro Cognitivo Leve",
            "want_money": "Me gustaría ser remunerado por participar en la investigación",
            "looking_for_clinical_contact": "Estoy buscando contacto clínico o tratamiento como parte de un ensayo clínico"
        },
        "sex": {
            "male": "Masculino",
            "female": "Femenino",
            "other": "Otro"
        },
        "consent": {
            "accept": "He leído y aceptado los Términos de Uso y la Política de Privacidad. Entiendo que Storyteller no proporciona asesoramiento médico ni recomendaciones de salud. Entiendo que puedo ser contactado para discutir mis resultados."
        },
        "education": {
            "didnt_complete_high_school": "No terminó la preparatoria o high school",
            "high_school": "Terminó la preparatoria o high school",
            "upper_secondary": "Realizó algunos estudios después de terminar la preparatoria o high school",
            "bachelors_degree": "Obtuvo una licenciatura, bachelor o un título equivalente",
            "masters_degree": "Obtuvo una maestría, master o un título superior"
        },
        "hispanic": {
            "no": "No, no soy hispano\/a o latino\/a",
            "yes": "Sí, soy hispano\/a o latino\/a",
            "unknown": "No lo sé"
        },
        "race": {
            "american_indian_or_alaska_native": "Indígena Americano o Nativo de Alaska",
            "asian": "Asiático",
            "african_american": "Negro o Afroamericano",
            "hawaiian_or_other_islander": "Hawaiano Nativo u otro Isleño del Pacífico",
            "white": "Blanco",
            "other": "Alguna Otra Raza",
            "asian_or_asian_british": "Asiático o Asiático Británico",
            "black_black_british_carribean_or_afrikan": "Negro, Negro Británico, Caribeño o Africano",
            "mixed_or_multiple_groups": "Grupos étnicos mixtos o múltiples"
        },
        "isCaregiver": {
            "myself": "Quiero hacer la prueba yo mismo",
            "someone-else": "La prueba es para otra persona"
        },
        "isPersonNearby": {
            "yes": "Sí, está aquí y lista",
            "no": "No, me gustaría enviarle una invitación para que pueda hacer la prueba más tarde"
        },
        "caregiverShare": {
            "email": "A una dirección de correo electrónico",
            "sms": "Por mensaje de texto (SMS) a un número de celular"
        },
        "study_consent": {
            "agree": "Estoy de acuerdo en participar."
        }
    },
    "screens": {
        "welcomeSelfService": {
            "title": "¡Bienvenido a Storyteller! 👋",
            "description": "Aquí puede evaluar la edad de su cerebro desde la comodidad de su propio hogar.",
            "language": "Primero, elija su idioma nativo o el que habla mejor:",
            "proficiencyPlaceholder": "Elija el nivel de dominio..."
        },
        "progressSaved": {
            "caption": "¡Su progreso ha sido guardado!",
            "instruction": "Revise su correo electrónico para obtener un enlace y regresar a Storyteller cuando le convenga.",
            "action": "**Ahora puede salir del sitio.**"
        },
        "getMatched": {
            "caption": "En esta breve prueba de edad cerebral usted:",
            "list": [
                "Responderá algunas preguntas sencillas.",
                "Revise y acepte un consentimiento de estudio.",
                "Completará algunos breves ejercicios de habla.",
                "Compartirá sus resultados con uno de nuestros sitios asociados, quienes podrían ponerse en contacto con usted para discutir sus resultados."
            ]
        },
        "novoicPrivacy": {
            "caption": "Queremos informarle sobre el funcionamiento de nuestros servicios y cómo manejamos y compartimos sus datos.",
            "description": "Por favor, revise nuestros [Términos de Uso](https:\/\/novoic.com\/storyteller\/tos) y [Política de Privacidad](https:\/\/novoic.com\/storyteller\/privacy)."
        },
        "studyMotivation": {
            "caption": "¿Qué lo motivó a hacer Storyteller hoy?",
            "description": "Esta pregunta es opcional. Por favor, elija todas las opciones que correspondan."
        },
        "email": {
            "caption": "¿Cuál es el mejor correo electrónico para contactarlo?",
            "comment": "Al ingresar su dirección de correo electrónico, está aceptando que nosotros, o nuestros sitios asociados, podamos contactarle. Consulte nuestra [Política de Privacidad](https:\/\/novoic.com\/storyteller\/privacy) para más detalles.",
            "emailPlaceholder": "Su dirección de correo electrónico...",
            "descriptionOptional": "Esto es opcional. Ingrese un correo electrónico para recibir un enlace. Esto le permitirá hacer una pausa y continuar más tarde sin perder su progreso.",
            "descriptionRequired": "Nosotros, o nuestros sitios asociados, podremos utilizar este correo electrónico para ponernos en contacto con usted, incluso para discutir sus resultados."
        },
        "name": {
            "caption": "¿Cuál es su nombre completo?",
            "namePlaceholder": "Su nombre completo…"
        },
        "dob": {
            "caption": "¿Cuál es su fecha de nacimiento?",
            "description": "Utilizamos esta información para calcular su edad."
        },
        "excludedAge": {
            "caption": "Agradecemos su interés, pero por ahora no podemos incluirlo en Storyteller.",
            "description": "Actualmente, Storyteller solo está disponible para personas de 50 años en adelante. ¡Gracias por su comprensión!",
            "action": "**Ahora puede salir del sitio.**"
        },
        "excludedLanguage": {
            "caption": "Agradecemos su interés, pero por ahora no podemos incluirlo en Storyteller.",
            "description": "Actualmente, Storyteller solo está disponible para personas que son hablantes nativos o que tienen un dominio fluido en el idioma seleccionado. ¡Gracias por su comprensión!",
            "action": "**Ahora puede salir del sitio.**"
        },
        "sex": {
            "caption": "¿Cuál fue su sexo de nacimiento?"
        },
        "education": {
            "caption": "¿Cuál es su nivel de estudios?",
            "description": "Escoja la opción que mejor le describa."
        },
        "hispanic": {
            "caption": "¿Se identifica usted como hispano\/a o latino\/a?",
            "description": "Esta pregunta es opcional. Puede presionar \"Omitir\" si prefiere no responder."
        },
        "race": {
            "caption": "¿Cómo describiría su origen racial?",
            "description": "Esta pregunta es opcional. Su respuesta nos ayuda a asegurar que nuestros datos sean representativos. Si no desea responder, simplemente presione \"Omitir\"."
        },
        "noSites": {
            "caption": "¿Le gustaría que nos comuniquemos con usted cuando tengamos un sitio asociado cerca de su ubicación?",
            "description": "De momento no contamos con sitios asociados cerca de usted, pero este escenario podría cambiar en el futuro. Si nos permite contactarlo más adelante, por favor comparta su correo electrónico.",
            "emailPlaceholder": "Su dirección de correo electrónico...",
            "comment": "Su privacidad es importante para nosotros. Para más detalles, vea nuestra [Política de Privacidad](https:\/\/novoic.com\/storyteller\/privacy)."
        },
        "studymatchSuccess": {
            "caption": "¡Éxito en la coincidencia de estudio!",
            "description": "Sus respuestas indican que podría ser un buen candidato para un ensayo o estudio clínico, y hemos encontrado un sitio de estudio cerca de usted que está reclutando.",
            "action": "**¿Estás listo para algunas tareas rápidas de memoria basadas en el habla? Entonces, por favor, continúa leyendo nuestra hoja de información del estudio y el formulario de consentimiento.**"
        },
        "demographicsComplete": {
            "caption": "¡Gracias! Ahora pasemos a algunos ejercicios de habla.",
            "next": "Por favor, escuche las instrucciones y responda simplemente hablando. Sus respuestas serán grabadas y analizadas. Los resultados serán compartidos con nuestro sitio asociado, quien puede ponerse en contacto con usted.",
            "action": "Puede hacer esto ahora o volver más tarde (le enviaremos un enlace web)."
        },
        "confirmTime": {
            "caption": "Confirme que está en un lugar tranquilo y que no lo interrumpirán en los próximos 10 minutos.",
            "instruction": "Apague cualquier otro aparato que haga ruido a su alrededor (como la televisión o la radio) o vaya a un lugar más tranquilo."
        },
        "saveProgress": {
            "caption": "¡No olvide ingresar su dirección de correo electrónico para guardar su progreso!",
            "description": "Le enviaremos un enlace a su dirección de correo electrónico. Este le permitirá pausar y continuar con la prueba cuando quiera, sin perder su progreso.",
            "emailPlaceholder": "Su dirección de correo electrónico...",
            "comment": "Su privacidad es importante para nosotros. Para más detalles, vea nuestra [Política de Privacidad](https:\/\/novoic.com\/storyteller\/privacy)."
        },
        "leave": {
            "caption": "Lamentamos que se vaya.",
            "description": "Esperamos que decida volver a contribuir en la investigación clínica.",
            "action": "**Ahora puede salir del sitio.**"
        },
        "confirmAid": {
            "caption": "Confirme que está usando sus gafas y\/o sus audífonos, si es que los usa normalmente.",
            "description": "Es importante que pueda leer y escuchar las instrucciones con claridad."
        },
        "confirmOnYourOwn": {
            "caption": "Confirme que hará las tareas por su cuenta y que no tomará notas.",
            "description": "Es importante que no reciba ayuda y que no tome notas."
        },
        "confirmFocus": {
            "caption": "Confirme que tratará de concentrarse y que hará las tareas de la mejor manera posible.",
            "description": "Algunas tareas pueden ser bastante difíciles; se supone que deben serlo. No se preocupe, incluso las personas con una gran memoria cometen errores. Pero para lograr resultados exactos, es importante que haga las tareas de la mejor manera posible."
        },
        "soundCheck": {
            "caption": "Suba el volumen de su dispositivo y luego pulse el botón para chequear el sonido."
        },
        "welcomeADNI": {
            "caption": "¡Bienvenido a Storyteller!",
            "description": "Aquí, usted hará algunas tareas oralmente para chequear su memoria.",
            "instructions": "Esto durará aproximadamente 10 minutos. Mientras completa Storyteller, escuchará las instrucciones de las tareas. Para responder, respóndale a su dispositivo. Sus respuestas servirán para chequear su memoria."
        },
        "studymatchComplete": {
            "caption": "Ahora puede salir del sitio.",
            "action": "Recuerde, puede recibir un correo electrónico o una llamada telefónica de uno de nuestros sitios asociados."
        },
        "memoryComplete": {
            "caption": "¡Ha completado los ejercicios de habla!",
            "description": "Compartiremos sus respuestas con uno de nuestros sitios asociados, quienes podrían ponerse en contacto con usted.",
            "action": "Como último paso, por favor ingrese sus datos de contacto para que nosotros, o nuestros socios, podamos comunicarnos con usted."
        },
        "csat": {
            "caption": "¡Gracias por completar Storyteller! 🎉",
            "question": "¿Disfrutó de Storyteller?",
            "action": "Es posible que uno de nuestros sitios asociados se ponga en contacto con usted."
        },
        "recordingPermissions": {
            "caption": "Ahora necesitamos permiso para acceder a su micrófono.",
            "description": "Para que la prueba funcione, necesitamos grabarlo mientras habla. Solo podremos grabarlo durante la prueba.",
            "instructions": "![Record Icon](https:\/\/novoic-static.s3.us-west-2.amazonaws.com\/rec.svg)&nbsp;&nbsp;**Nota**: Siempre verá este punto rojo cuando esté siendo grabado."
        },
        "noSound": {
            "caption": "Intente los próximos pasos y vuelva a intentarlo.",
            "instructions": "Vaya a \"Ajustes\" (\"Settings\")→ Bluetooth y apáguelo o encuentre este&nbsp;&nbsp;![Bluetooth](https:\/\/novoic-static.s3.us-west-2.amazonaws.com\/bluetooth.svg)&nbsp;&nbsp;ícono y pulse para ponerlo en modo desactivado (“off”).",
            "list": [
                {
                    "icon": "sound",
                    "text": "Ajuste o active el volumen de su dispositivo."
                },
                {
                    "icon": "headset",
                    "text": "Desconecte los auriculares\/audífonos que esté usando."
                },
                {
                    "icon": "bluetooth",
                    "text": "Desconecte el Bluetooth."
                }
            ]
        },
        "noMicrophone": {
            "caption": "Parece que no se han otorgado los permisos para acceder a su micrófono.",
            "browsers": {
                "chrome": {
                    "title": "Google Chrome",
                    "icon": "chrome",
                    "instructions": "- Haga clic en el ícono del candado, escudo o micrófono en la barra de direcciones.\n - Cambie el permiso a **Permitir** y cierre la ventana emergente. \n - Haga clic en **Intentar de nuevo**.\n - **Permita** el acceso al micrófono en la ventana emergente en la página siguiente."
                },
                "safari": {
                    "title": "Safari",
                    "icon": "safari",
                    "instructions": "#### Primero:\n- Pulse **Intentar de nuevo**.\n- **Permita** el acceso al micrófono en la ventana emergente en la página siguiente.\n#### En caso de no poder:\n- Pulse **Safari** en la barra del menú y seleccione **Preferencias**.\n- Pulse la pestaña **Sitios web** y haga clic en **Micrófono**.\n- Cambie los permisos de nuestro sitio a **Permitir**.\n- Cierre las Preferencias y pulse **Intentar de nuevo**.\n- **Permita** el acceso al micrófono en la ventana emergente en la página siguiente."
                },
                "firefox": {
                    "title": "Firefox",
                    "icon": "firefox",
                    "instructions": "- Haga clic en el ícono del candado, escudo o micrófono en la barra de direcciones. \n - Haga clic en la **x** junto a **Bloqueado**.\n - Haga clic en **Intentar de nuevo**.\n - **Permita** el acceso al micrófono en la ventana emergente en la página siguiente."
                },
                "opera": {
                    "title": "Opera",
                    "icon": "opera",
                    "instructions": "- Haga clic en el ícono del candado, escudo o micrófono en la barra de direcciones.\n - Alterne los permisos del micrófono y haga clic en **Hecho**.\n - Haga clic en **Intentar de nuevo**.\n - **Permita** el acceso al micrófono en la ventana emergente en la página siguiente."
                },
                "edge": {
                    "title": "Microsoft Edge",
                    "icon": "edge",
                    "instructions": "- Haga clic en el ícono del candado, escudo o micrófono en la barra de direcciones. \n - Alterne los permisos del micrófono y haga clic en **Hecho**.\n - Haga clic en **Intentar de nuevo**.\n - **Permita** el acceso al micrófono en la ventana emergente en la página siguiente."
                }
            },
            "mobile": {
                "ios": {
                    "title": "iPhone\/iPad",
                    "icon": "ios",
                    "instructions": "#### Primero:\n- Toque **Intentar de nuevo**.\n- **Permita** el acceso al micrófono en la ventana emergente en la página siguiente.\n#### En caso de no poder:\n- **Actualice** la página tocando el símbolo de actualización en la barra de direcciones.\n- Toque **Intentar de nuevo**.\n- **Permita** el acceso al micrófono en la ventana emergente en la página siguiente."
                },
                "android": {
                    "title": "Android",
                    "icon": "android",
                    "instructions": "- Haga clic en el ícono del candado, escudo o micrófono junto a su barra de direcciones y, si hay permisos de micrófono, actívelos. Es posible que necesite desplazarse para visualizar la barra de direcciones. Luego, es posible que necesite actualizar la página.\n- Toque **Intentar de nuevo**\n- **Permita** el acceso al micrófono en la ventana emergente en la página siguiente."
                }
            }
        },
        "micCheck": {
            "captions": {
                "default": "Vamos a verificar su micrófono. Le diremos una oración. Repítala cuando el botón esté rojo.",
                "playing": "Escuche atentamente.",
                "recording": "Repita la oración."
            },
            "transcript": "Hoy a la noche hay una fiesta en la calle con música y baile."
        },
        "asrt1": {
            "captions": {
                "default": "Ahora le contaremos un cuento. Escuche el cuento y, luego, vuelva a contarlo con todos los detalles que pueda.",
                "playing": "Escuche atentamente.",
                "recording": "Vuelva a contar el cuento con todos los detalles que pueda."
            }
        },
        "asrt1success": {
            "caption": "¡Buen trabajo!",
            "description": "Continúe con la tarea siguiente cuando esté listo."
        },
        "asrt2": {
            "captions": {
                "default": "Ahora le contaremos otro cuento. Escuche el cuento y, luego, vuelva a contarlo con todos los detalles que pueda.",
                "playing": "Escuche atentamente.",
                "recording": "Vuelva a contar el cuento con todos los detalles que pueda."
            }
        },
        "asrt2success": {
            "caption": "¡Ya casi!",
            "description": "Continúe con el paso siguiente cuando esté listo."
        },
        "cat": {
            "instructions": "**Por ejemplo**, si la categoría fuera \"plantas\", podría decir \"rosa\", \"roble\", etc. La grabación se detendrá automáticamente a los 60 segundos.",
            "captions": {
                "default": "Nombraremos una categoría. Enumere la mayor cantidad de elementos de esa categoría en 60 segundos.",
                "playing": "Escuche atentamente.",
                "recording": "Nombre todos los animales en los que pueda pensar."
            },
            "cta": {
                "play": "Pulse para comenzar",
                "playing": "Escuche",
                "recording": "Hable"
            }
        },
        "catSuccess": {
            "caption": "¿Está listo para la última tarea?",
            "description": "Continúe con el paso siguiente cuando esté listo."
        },
        "asrt1delayed": {
            "captions": {
                "default": "Pulse el botón para escuchar las instrucciones.",
                "playing": "Escuche atentamente.",
                "recording": "Vuelva a contar el cuento con todos los detalles que pueda."
            }
        },
        "survey": {
            "caption": "Por favor, responda las siguientes preguntas:",
            "someoneElseSpeaking": "¿Hemos grabado a alguien, excepto a usted, durante las tareas?",
            "withoutDistraction": "¿Logró completar las tareas sin distracciones?",
            "hearingImpairments": "¿Tiene alguna dificultad visual o auditiva que no se corrija con gafas o audífonos?"
        },
        "csatADNI": {
            "caption": "¡Gracias por completar Storyteller!",
            "question": "¿Disfrutó de Storyteller?"
        },
        "micCheckSuccess": {
            "caption": "¡Fantástico!",
            "description": "Sus altavoces y su micrófono están funcionando."
        },
        "noTest": {
            "caption": "Esta prueba ya se ha completado o nunca existió.",
            "description": "Si tiene alguna pregunta, por favor [contacte a nuestro soporte](https:\/\/help.novoic.com)."
        },
        "postcode": {
            "caption": "¿Cuál es su código postal?",
            "description": "Esto nos ayuda a identificar nuestros sitios asociados más cercanos.",
            "postcodePlaceholder": "Por ejemplo, 10001"
        },
        "phoneInput": {
            "caption": "¿Cuál es el mejor número de teléfono para contactarlo?",
            "description": "Ingrese su número de teléfono y pulse **Verificar** para obtener su código de verificación de 4 dígitos mediante un mensaje de texto:",
            "comment": "Al ingresar su número de teléfono, acepta que nosotros, o nuestros sitios asociados, podamos enviarle mensajes o llamarle. Las llamadas pueden ser grabadas para fines de calidad. Consulte nuestra [Política de privacidad](https:\/\/novoic.com\/storyteller\/privacy) para obtener más detalles.",
            "placeholder": "+1"
        },
        "registeringInterest": {
            "caption": "¡Gracias por registrar su interés!",
            "description": "Nos comunicaremos con usted en caso de tener un sitio asociado cerca de donde usted se encuentra.",
            "action": "**Ahora puede salir del sitio.**"
        },
        "noSitesNearby": {
            "caption": "Por ahora, no contamos con un sitio asociado cerca de usted.",
            "description": "Le avisaremos cuando tengamos uno cerca de su ubicación.",
            "action": "**Ahora puede salir del sitio.**"
        },
        "phoneVerification": {
            "caption": "Verifique su número de teléfono",
            "description": "Ingrese el código de 4 dígitos del mensaje de texto enviado a **{{phone}}:**",
            "resend": "**¿No recibió el código?**"
        },
        "language": {
            "caption": "Por favor, elija su idioma nativo o el que habla mejor:"
        },
        "isCaregiver": {
            "caption": "Primero, ¿va a realizar la prueba usted mismo o es para otra persona?"
        },
        "isPersonNearby": {
            "caption": "¿La persona que va a realizar la prueba está con usted y lista para hacerla?"
        },
        "caregiverWarning": {
            "caption": "Muy bien. Puede apoyar a la persona que realiza la prueba para responder las preguntas en pantalla, pero asegúrese de que realicen los ejercicios de habla por su cuenta.",
            "comment": "**Es importante** que la persona realice los ejercicios de habla de forma independiente, sin ayuda."
        },
        "personalInvite": {
            "caption": "Personalice la invitación para el destinatario.",
            "description": "Esto es opcional. Si incluye el nombre del destinatario y su nombre en la invitación, es posible que la persona se sienta más inclinada a completar la prueba.",
            "senderNamePlaceholder": "Su nombre completo...",
            "recipientNamePlaceholder": "Nombre del destinatario"
        },
        "caregiverShare": {
            "caption": "¿Cómo prefiere enviar la invitación para la prueba?"
        },
        "inviteeEmailSent": {
            "caption": "¡Invitación enviada!",
            "instruction": "Se ha enviado una invitación con el enlace de la prueba a **{{email}}**",
            "action": "**Puede cerrar esta ventana ahora.**"
        },
        "inviteeSMSSent": {
            "caption": "¡Invitación enviada!",
            "instruction": "Se ha enviado una invitación con el enlace de la prueba a **{{phone}}**",
            "action": "**Puede cerrar esta ventana ahora.**"
        },
        "inviteeEmail": {
            "caption": "Para invitar a alguien a completar la prueba, por favor ingrese su dirección de correo electrónico aquí:",
            "comment": "Al ingresar la dirección de correo electrónico, confirmas que tienes el consentimiento del propietario y aceptas permitirnos a nosotros, o a nuestros socios del sitio de investigación, contactarlos acerca de posibles ensayos. Consulta nuestra [Política de Privacidad](https:\/\/novoic.com\/storyteller\/privacy) para más detalles.",
            "emailPlaceholder": "Dirección de email..."
        },
        "inviteeSMS": {
            "caption": "Para invitar a alguien a completar la prueba, por favor ingrese su número de teléfono móvil aquí:",
            "placeholder": "+1",
            "comment": "Al ingresar el número de teléfono, confirma que tiene el consentimiento del propietario y acepta permitirnos a nosotros, o a nuestros socios del sitio de investigación, contactarlos sobre posibles ensayos. Las llamadas pueden ser automatizadas y grabadas para fines de calidad. Consulte nuestra [Política de Privacidad](https:\/\/novoic.com\/storyteller\/privacy) para obtener más detalles."
        },
        "aggregatedConfirmations": {
            "caption": "Está a punto de comenzar las tareas basadas en el habla. Por favor confirme que usted está:",
            "list": [
                {
                    "text": "En un lugar tranquilo donde no será interrumpido durante los próximos 10 minutos.",
                    "icon": "quiet-place"
                },
                {
                    "text": "Usando sus gafas y\/o audífonos si normalmente los usa.",
                    "icon": "have-aid"
                },
                {
                    "text": "Hará las tareas por su cuenta y sin tomar notas.",
                    "icon": "no-notes"
                },
                {
                    "text": "¡Tratará de concentrarse y hacer lo mejor que pueda!",
                    "icon": "on-my-own"
                }
            ]
        },
        "siteSpecificWelcome": {
            "title": "¡Bienvenido a Storyteller! 👋",
            "paragraph1": "{{site}} le invita a completar esta prueba rápida y fácil de usar para evaluar su memoria.",
            "paragraph2": "Una vez que complete Storyteller, podrá programar una visita virtual con un especialista en investigación de {{site}}, sin costo alguno, para discutir sus resultados y explorar los recursos disponibles en su comunidad.",
            "paragraph3": "Inicie aquí su camino hacia la comprensión y mejora de la salud de su memoria."
        },
        "redirect": {
            "processing": "Procesando...",
            "halt": "Esto está tomando un poco más de tiempo de lo esperado. Espere...",
            "tooLong": "Esto no debería haber tardado tanto.",
            "description": "Por favor, haga clic en el botón 'Continuar' a continuación para finalizar la prueba."
        },
        "networkFailed": {
            "title": "Vaya, parece que se perdió la conexión.",
            "instructions": "- Intente trasladarse a un lugar con una buena conexión a internet.\n- Si está utilizando la conexión de datos móviles, intente conectarse a una red WiFi.\n- Si está utilizando WiFi en su dispositivo móvil, podría intentar desconectarse y utilizar la conexión de datos móviles en su lugar."
        },
        "unsupportedBrowser": {
            "caption": "Por favor, abra Storyteller en un navegador de internet diferente.",
            "instructions": "La aplicación de Facebook no soporta esta prueba.\n\n&nbsp;\n\nPara continuar, por favor haga lo siguiente: \n- Toque los tres puntos (···) en la parte superior de la página.\n- Seleccione **Abrir en** ... para abrir Storyteller en su navegador de internet preferido, como Chrome, Firefox, Edge o Safari."
        },
        "asrt3": {
            "captions": {
                "recording": "Vuelva a contar el cuento con todos los detalles que pueda.",
                "default": "Ahora le contaremos un cuento. Escuche el cuento y, luego, vuelva a contarlo con todos los detalles que pueda.",
                "playing": "Escuche atentamente."
            }
        },
        "asrt3success": {
            "caption": "¡Buen trabajo!",
            "description": "Continúe con la tarea siguiente cuando esté listo."
        },
        "asrt3delayed": {
            "captions": {
                "default": "Pulse el botón para escuchar las instrucciones.",
                "playing": "Escuche atentamente.",
                "recording": "Vuelva a contar el cuento con todos los detalles que pueda."
            }
        },
        "asrt6": {
            "captions": {
                "default": "Ahora le contaremos otro cuento. Escuche el cuento y, luego, vuelva a contarlo con todos los detalles que pueda.",
                "playing": "Escuche atentamente.",
                "recording": "Vuelva a contar el cuento con todos los detalles que pueda."
            }
        },
        "asrt6success": {
            "caption": "¡Ya casi!",
            "description": "Continúe con el paso siguiente cuando esté listo."
        },
        "asrt4": {
            "captions": {
                "default": "Ahora le contaremos un cuento. Escuche el cuento y, luego, vuelva a contarlo con todos los detalles que pueda.",
                "playing": "Escuche atentamente.",
                "recording": "Vuelva a contar el cuento con todos los detalles que pueda."
            }
        },
        "asrt4success": {
            "caption": "¡Buen trabajo!",
            "description": "Continúe con la tarea siguiente cuando esté listo."
        },
        "asrt4delayed": {
            "captions": {
                "default": "Pulse el botón para escuchar las instrucciones.",
                "playing": "Escuche atentamente.",
                "recording": "Vuelva a contar el cuento con todos los detalles que pueda."
            }
        },
        "asrt5": {
            "captions": {
                "default": "Ahora le contaremos otro cuento. Escuche el cuento y, luego, vuelva a contarlo con todos los detalles que pueda.",
                "playing": "Escuche atentamente.",
                "recording": "Vuelva a contar el cuento con todos los detalles que pueda."
            }
        },
        "asrt5success": {
            "caption": "¡Ya casi!",
            "description": "Continúe con el paso siguiente cuando esté listo."
        },
        "asrt8": {
            "captions": {
                "default": "Ahora le contaremos un cuento. Escuche el cuento y, luego, vuelva a contarlo con todos los detalles que pueda.",
                "playing": "Escuche atentamente.",
                "recording": "Vuelva a contar el cuento con todos los detalles que pueda."
            }
        },
        "asrt8success": {
            "caption": "¡Buen trabajo!",
            "description": "Continúe con la tarea siguiente cuando esté listo."
        },
        "asrt8delayed": {
            "captions": {
                "default": "Pulse el botón para escuchar las instrucciones.",
                "playing": "Escuche atentamente.",
                "recording": "Vuelva a contar el cuento con todos los detalles que pueda."
            }
        },
        "asrt9": {
            "captions": {
                "default": "Ahora le contaremos otro cuento. Escuche el cuento y, luego, vuelva a contarlo con todos los detalles que pueda.",
                "playing": "Escuche atentamente.",
                "recording": "Vuelva a contar el cuento con todos los detalles que pueda."
            }
        },
        "asrt9success": {
            "caption": "¡Ya casi!",
            "description": "Continúe con el paso siguiente cuando esté listo."
        }
    },
    "audio": {
        "soundCheck": {
            "file": "ES\/soundcheck.mp3",
            "duration": "2500"
        },
        "asrt1": {
            "file": "ES\/S1_immediate.opus",
            "duration": "75170"
        },
        "asrt2": {
            "file": "ES\/S2_immediate.opus",
            "duration": "84380"
        },
        "asrt1delayed": {
            "file": "ES\/S1_delayed.opus",
            "duration": "18530"
        },
        "cat": {
            "file": "ES\/CAT_Animals.opus",
            "duration": "24300"
        },
        "qc": {
            "file": "ES\/QC.opus",
            "duration": "29540"
        },
        "qc_fail_1": {
            "file": "ES\/QC_fail_1.opus",
            "duration": "20260"
        },
        "qc_fail_2": {
            "file": "ES\/QC_fail_2.opus",
            "duration": "24150"
        },
        "asrt3": {
            "file": "ES\/S3_immediate.opus",
            "duration": "74814"
        },
        "asrt3delayed": {
            "file": "ES\/S3_delayed.opus",
            "duration": "18439"
        },
        "asrt6": {
            "file": "ES\/S6_immediate.opus",
            "duration": "75681"
        },
        "asrt4": {
            "file": "ES\/S4_immediate.opus",
            "duration": "76776"
        },
        "asrt4delayed": {
            "file": "ES\/S4_delayed.opus",
            "duration": "18244"
        },
        "asrt5": {
            "file": "ES\/S5_immediate.opus",
            "duration": "75681"
        },
        "asrt8": {
            "file": "ES\/S8_immediate.opus",
            "duration": "78638"
        },
        "asrt8delayed": {
            "file": "ES\/S8_delayed.opus",
            "duration": "20193"
        },
        "asrt9": {
            "file": "ES\/S9_immediate.opus",
            "duration": "71408"
        }
    }
}